const defaults = {
	formId: 0,
	steps: [],
	primarySteps: [],
	loadingDelayMs: 2000,
	boundaryClass: '',
	adviceContainerClass: '',
	adviceLoadingMarkup: '',
	adviceStaleMarkup: '',
	adviceNotReadyMarkup: '',
	adviceErrorMarkup: '',
	adviceErrorText: '',
	adviceLoadingText: '',
	adviceContinueLabel: '',
	adviceResultEndpoint: '',
	adviceResultNonce: '',
	adviceRequestTimeoutMs: 15000,
	expectedAdviceKeys: [],
	adviceInputMap: {},
	roiBoundaryClass: '',
	roiContainerClass: '',
	roiLoadingMarkup: '',
	roiNotReadyMarkup: '',
	roiErrorMarkup: '',
	roiErrorText: '',
	roiResultEndpoint: '',
	roiResultNonce: '',
	expectedRoiKeys: [],
	roiInputMap: {},
	hiddenFieldMap: {},
	helperTextMap: {},
	statuses: {
		success: 'success',
		stale: 'stale',
		error: 'error',
	},
	debug: false,
};

const RUNTIME_CONFIG_SELECTOR = 'script.sd-config-runtime';

/**
* Responsibility:
* - Parse configurator runtime JSON from the current configurator root markup.
*
* Touches:
 * - Reads the text content of the local `.sd-config-runtime` script node.
* - Writes parse failures to the browser console for QA visibility.
*
* Guarantees:
* - Returns a plain object for valid JSON and an empty object for missing or invalid runtime markup.
*/
function readRuntimeConfigFromRoot(configRoot) {
	if (!(configRoot instanceof HTMLElement)) {
		return {};
	}

	const runtimeScript = configRoot.querySelector(RUNTIME_CONFIG_SELECTOR);
	if (!(runtimeScript instanceof HTMLScriptElement)) {
		return {};
	}

	const runtimeJson = String(runtimeScript.textContent || '').trim();
	if (runtimeJson === '') {
		return {};
	}

	try {
		const parsedRuntime = JSON.parse(runtimeJson);
		return parsedRuntime && typeof parsedRuntime === 'object' ? parsedRuntime : {};
	} catch (error) {
		console.error('Failed to parse the configurator runtime config.', error);
		return {};
	}
}

/**
* Responsibility:
* - Resolve the merged configurator runtime config for one rendered configurator root.
*
* Touches:
* - Reads the DOM-embedded JSON runtime config from the supplied configurator root.
*
* Guarantees:
* - Returns the defaults merged with the current page's runtime config payload.
*/
export function getRuntimeConfig(configRoot) {
	const runtime = readRuntimeConfigFromRoot(configRoot);

	return {
		...defaults,
		...runtime,
	};
}
